import {IntermediatePart} from "../../intermediatePart";

export default class BottomHandle extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bottom_handle';
    this.partName = 'Bottom Handle';
    this.translateId = "visualizer.kitchen.cabinet.bottom_handle";
    this.hasAdditionalParts = true;
    this.canBeDisabled = true;
  }

}
